import {
  VALUE_NOT_VALID,
  ValidationTypes,
  STRING_TYPE,
  ValidaitonMessage,
  TEXTONLYREGEX,
  TEXT_VALUE_ERROR,
  NUMBERREGEX,
  NUMERIC_VALUE_ERROR
} from "../App.config";
import * as utilities from "../utilities/utils";

const validateField = (valueToValidate, context = undefined) => {

  let errorValidationCount = Object.keys(valueToValidate.validation).length;
  for (let validator = 0; validator < errorValidationCount; validator++) {
    switch (Object.keys(valueToValidate.validation)[validator]) {
      case ValidationTypes.TERMSANDCONDITION:
        if (
          valueToValidate.value
        ) {
          valueToValidate.error = "";
        } else {

          //If component don't need transaltion for errors
          if (context) {
            valueToValidate.error = context.t(
              "STD-Employer-Statement.form.error.required"
            );
          } else {
            valueToValidate.error = ValidaitonMessage.Required;
          }
          errorValidationCount = -1;
        }

        break;
      case ValidationTypes.REQUIRED:{
        if (typeof valueToValidate.value === STRING_TYPE
          ? valueToValidate.value.trim().length
          : valueToValidate.value.length
        ) {
          valueToValidate.error = "";
        } else {
          //If component don't need transaltion for errors
          if (context) {
            valueToValidate.error = context.t(
              "STD-Employer-Statement.form.error.required"
            );
          } else {
            valueToValidate.error = ValidaitonMessage.Required;
          }
          errorValidationCount = -1;
        }

        break;}
      case ValidationTypes.isDate:
        if (
          typeof valueToValidate.value === "object" &&
          valueToValidate.value !== null &&
          utilities.formatDate(valueToValidate.value).length
        ) {
          valueToValidate.error = "";
        } else {
          if (context) {
            valueToValidate.error = context.t(
              "STD-Employer-Statement.form.error.required"
            );
          } else {
            valueToValidate.error = ValidaitonMessage.Required;
          }
          errorValidationCount = -1;
        }
        break;
      case ValidationTypes.isTime:
        if (valueToValidate.value !== null) {
          valueToValidate.error = "";
        } else {
          if (context) {
            //todo - this needs to be change
            valueToValidate.error = context.t(
              "STD-Employer-Statement.form.error.required"
            );
          } else {
            valueToValidate.error = ValidaitonMessage.Required;
          }
          errorValidationCount = -1;
        }
        break;
      case ValidationTypes.MINLENGTH:
        if (valueToValidate?.value?.length) {
          if (
            valueToValidate.value.length >= valueToValidate.validation.minLength
          ) {
            valueToValidate.error = "";
          } else {
            if (context) {
              valueToValidate.error = `${context.t(
                "STD-Employer-Statement.form.error.min-length"
              )} ${valueToValidate.validation.minLength} ${context.t(
                "STD-Employer-Statement.form.error.character-long"
              )}`;
            } else {
              valueToValidate.error = `${ValidaitonMessage.MinLength} ${valueToValidate.validation.minLength} ${ValidaitonMessage.CharacterLong} `;
            }
            errorValidationCount = -1;
          }
        } else {
          valueToValidate.error = "";
        }
        break;
      case ValidationTypes.MAXLENGTH:
        if (valueToValidate?.value?.length) {
          if (
            valueToValidate.value.length <= valueToValidate.validation.maxLength
          ) {
            valueToValidate.error = "";
          } else {
            if (context) {
              valueToValidate.error = `
               ${context.t("STD-Employer-Statement.form.error.max-length")} ${valueToValidate.validation.maxLength
                } ${context.t(
                  "STD-Employer-Statement.form.error.character-long"
                )}`;
            } else {
              valueToValidate.error = `${ValidaitonMessage.MaxLength} ${valueToValidate.validation.maxLength} ${ValidaitonMessage.CharacterLong}`;
            }
            errorValidationCount = -1;
          }
        } else {
          valueToValidate.error = "";
        }
        break;
      case ValidationTypes.MINSINLENGTH:
        if (valueToValidate?.value?.length) {
          if (
            valueToValidate.value.replace(/-/g, "").replace(/ /g, "").length >= valueToValidate.validation.minSINLength
          ) {
            valueToValidate.error = "";
          } else {
            if (context) {
              valueToValidate.error = `${context.t(
                "STD-Employer-Statement.form.error.min-length"
              )} ${valueToValidate.validation.minSINLength} ${context.t(
                "STD-Employer-Statement.form.error.character-long"
              )}`;
            } else {
              valueToValidate.error = `${ValidaitonMessage.MinLength} ${valueToValidate.validation.minSINLength} ${ValidaitonMessage.CharacterLong} `;
            }
            errorValidationCount = -1;
          }
        } else {
          valueToValidate.error = "";
        }
        break;

      case ValidationTypes.MATCHPATTERN:
        if (valueToValidate?.value?.length) {
          let newValue = valueToValidate?.value;
          if(valueToValidate.validation.matchPattern == NUMBERREGEX){
            newValue = newValue.replace(/-/g, "").replace(/ /g, "");
          }
          if (
            String(newValue).match(
              valueToValidate.validation.matchPattern
            )
          ) 
          {
            valueToValidate.error = "";
          } 
          else 
          {
            if (valueToValidate.validation.matchPattern == TEXTONLYREGEX) {
              valueToValidate.error = TEXT_VALUE_ERROR;
            }
            else if (valueToValidate.validation.matchPattern == NUMBERREGEX) {
              valueToValidate.error = NUMERIC_VALUE_ERROR;
            }
            else if (context) {
              ///label : field key
              valueToValidate.error = valueToValidate.validation.type
                ? `${context.t(
                  "STD-Employer-Statement.form.error.invalid"
                )} ${context.t(valueToValidate.label)}`
                : VALUE_NOT_VALID;
            } else {
              valueToValidate.error = valueToValidate.validation.type
                ? `${ValidaitonMessage.Invalid} ${valueToValidate.validation.type}`
                : VALUE_NOT_VALID;
            }
            errorValidationCount = -1;
          }
        } else {
          valueToValidate.error = "";
        }
        break;
      case ValidationTypes.CUSTOMMATCHPATTERN:
        if (valueToValidate?.value?.length) {
          if (
            String(valueToValidate?.value).match(
              valueToValidate.validation.customMatchPattern
            )
          ) {
            valueToValidate.error = "";
          } else {
            valueToValidate.error = valueToValidate.validation.type
              ? valueToValidate.validation.type
              : VALUE_NOT_VALID;
            errorValidationCount = -1;
          }
        } else {
          valueToValidate.error = "";
        }
        break;

      default:
        errorValidationCount = -1;
        break;
    }
  }

  return valueToValidate;
};

export default validateField;
